export default {
  RETURN_KEY: 13
};



// WEBPACK FOOTER //
// ./src/ui/key-mapping.js